import { frontendURL } from '../../../../helper/URLHelper';

import BranchesIndex from './Index.vue';
import CreateStepWrap from './Create/Index.vue';
import EditStepWrap from './Edit/Index.vue';
import CreateBranch from './Create/CreateBranch.vue';
import EditBranch from './Edit/EditBranch.vue';
import AddAgents from './Create/AddAgents.vue';
import AddTeams from './Create/AddTeams.vue';
import EditAgents from './Edit/EditAgents.vue';
import EditTeams from './Edit/EditTeams.vue';
import FinishSetup from './FinishSetup.vue';
import SettingsContent from '../Wrapper.vue';
import SettingsWrapper from '../SettingsWrapper.vue';
import { FEATURE_FLAGS } from '../../../../featureFlags';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/branches'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'settings_branches_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'settings_branches_list',
          component: BranchesIndex,
          meta: {
            permissions: ['administrator', 'branch_manage'],
            featureFlag: FEATURE_FLAGS.BRANCH_MANAGEMENT,
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/branches'),
      component: SettingsContent,
      props: () => {
        return {
          headerTitle: 'BRANCHES_SETTINGS.HEADER',
          icon: 'i-lucide-building-2',
          showBackButton: true,
        };
      },
      children: [
        {
          path: 'new',
          component: CreateStepWrap,
          children: [
            {
              path: '',
              name: 'settings_branches_new',
              component: CreateBranch,
              meta: {
                permissions: ['administrator', 'branch_manage'],
                featureFlag: FEATURE_FLAGS.BRANCH_MANAGEMENT,
              },
            },
            {
              path: ':branchId/finish',
              name: 'settings_branches_finish',
              component: FinishSetup,
              meta: {
                permissions: ['administrator', 'branch_manage'],
                featureFlag: FEATURE_FLAGS.BRANCH_MANAGEMENT,
              },
            },
            {
              path: ':branchId/agents',
              name: 'settings_branches_add_agents',
              meta: {
                permissions: ['administrator', 'branch_manage'],
                featureFlag: FEATURE_FLAGS.BRANCH_MANAGEMENT,
              },
              component: AddAgents,
            },
            {
              path: ':branchId/teams',
              name: 'settings_branches_add_teams',
              meta: {
                permissions: ['administrator', 'branch_manage'],
                featureFlag: FEATURE_FLAGS.BRANCH_MANAGEMENT,
              },
              component: AddTeams,
            },
          ],
        },
        {
          path: ':branchId/edit',
          component: EditStepWrap,
          children: [
            {
              path: '',
              name: 'settings_branches_edit',
              component: EditBranch,
              meta: {
                permissions: ['administrator', 'branch_manage'],
                featureFlag: FEATURE_FLAGS.BRANCH_MANAGEMENT,
              },
            },
            {
              path: 'agents',
              name: 'settings_branches_edit_members',
              component: EditAgents,
              meta: {
                permissions: ['administrator', 'branch_manage'],
                featureFlag: FEATURE_FLAGS.BRANCH_MANAGEMENT,
              },
            },
            {
              path: 'teams',
              name: 'settings_branches_edit_teams',
              component: EditTeams,
              meta: {
                permissions: ['administrator', 'branch_manage'],
                featureFlag: FEATURE_FLAGS.BRANCH_MANAGEMENT,
              },
            },
            {
              path: 'finish',
              name: 'settings_branches_edit_finish',
              meta: {
                permissions: ['administrator', 'branch_manage'],
                featureFlag: FEATURE_FLAGS.BRANCH_MANAGEMENT,
              },
              component: FinishSetup,
            },
          ],
        },
      ],
    },
  ],
};
